import { render } from "./ExpertStatisticsQueueTableDetail.vue?vue&type=template&id=57e5ed34"
import script from "./ExpertStatisticsQueueTableDetail.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsQueueTableDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__